import React, { useEffect, useState } from "react";
import api from "../api/api";
import axios from "axios";
import AppLayout from "../components/layout/AppLayout";
import { useAuth } from "../contexts/AuthContext";

export default function UserProfile() {
  const { logout } = useAuth();
  const [activeTab, setActiveTab] = useState("profile");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);
  const [orders, setOrders] = useState([]);
  const [selectedBoleto, setSelectedBoleto] = useState(null);

  // Estados de visibilidade
  const [showCpf, setShowCpf] = useState(false);
  const [showCurrentPass, setShowCurrentPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const [profile, setProfile] = useState({
    name: "", email: "", phone: "", cpf: "",
    cep: "", address: "", number: "", complement: "",
    neighborhood: "", city: "", state: "",
  });

  const [passwords, setPasswords] = useState({ current: "", new: "", confirm: "" });

  useEffect(() => {
    loadData();
  }, []);

  // Lógica de CEP Automático
  useEffect(() => {
    const cep = profile.cep?.replace(/\D/g, "");
    if (cep?.length === 8) {
      handleCepBlur(cep);
    }
  }, [profile.cep]);

  const handleCepBlur = async (cep) => {
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
      if (!response.data.erro) {
        setProfile((prev) => ({
          ...prev,
          address: response.data.logradouro,
          neighborhood: response.data.bairro,
          city: response.data.localidade,
          state: response.data.uf,
        }));
        document.getElementById("address_number")?.focus();
      }
    } catch (err) {
      console.error("Erro ao buscar CEP");
    }
  };

  const loadData = async () => {
    try {
      setLoading(true);
      const userRes = await api.get("/users/me");
      setProfile(userRes.data);
      try {
        const ordersRes = await api.get("/payments/my-orders");
        setOrders(ordersRes.data || []);
      } catch (e) { console.warn("Pedidos não carregados"); }
    } catch (err) {
      setMessage({ type: "error", text: "Erro ao carregar dados" });
    } finally {
      setLoading(false);
    }
  };

  const saveProfile = async () => {
    setSaving(true);
    try {
      await api.put("/users/me", profile);
      setMessage({ type: "success", text: "Perfil e endereço atualizados!" });
    } catch {
      setMessage({ type: "error", text: "Erro ao salvar" });
    } finally { setSaving(false); }
  };

  const changePassword = async () => {
    if (passwords.new !== passwords.confirm) return setMessage({ type: "error", text: "As novas senhas não coincidem" });
    setSaving(true);
    try {
      await api.put("/users/me/password", { currentPassword: passwords.current, newPassword: passwords.new });
      setMessage({ type: "success", text: "Senha alterada com sucesso!" });
      setPasswords({ current: "", new: "", confirm: "" });
    } catch { setMessage({ type: "error", text: "Erro ao alterar senha" }); }
    finally { setSaving(false); }
  };

  if (loading) return <AppLayout><div className="p-20 text-center animate-pulse text-indigo-600 font-bold">Carregando...</div></AppLayout>;

  return (
    <AppLayout>
      <div className="bg-slate-50 min-h-screen pb-20">
        <div className="max-w-5xl mx-auto p-6">
          
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
            <div>
              <h1 className="text-3xl font-black text-slate-800">Olá, {profile.name?.split(' ')[0]}!</h1>
              <p className="text-slate-500 text-sm">Gerencie seu perfil e endereço.</p>
            </div>
            <button onClick={logout} className="text-red-500 font-bold hover:bg-red-50 p-3 rounded-xl transition">Sair</button>
          </div>

          <div className="flex gap-2 mb-8 bg-slate-200 p-1 rounded-2xl w-fit">
            <button onClick={() => setActiveTab("profile")} className={`px-8 py-2.5 rounded-xl font-bold transition-all ${activeTab === "profile" ? "bg-white text-indigo-600 shadow-md" : "text-slate-500"}`}>👤 Perfil</button>
            <button onClick={() => setActiveTab("orders")} className={`px-8 py-2.5 rounded-xl font-bold transition-all ${activeTab === "orders" ? "bg-white text-indigo-600 shadow-md" : "text-slate-500"}`}>💳 Meus Pedidos</button>
          </div>

          {message && (
            <div className={`mb-6 p-4 rounded-2xl font-bold ${message.type === "success" ? "bg-emerald-50 text-emerald-600 border border-emerald-100" : "bg-red-50 text-red-600 border border-red-100"}`}>
              {message.text}
            </div>
          )}

          {activeTab === "profile" ? (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2 space-y-6">
                
                <section className="bg-white rounded-[32px] shadow-sm border border-slate-200 p-8">
                  <h2 className="text-xl font-bold mb-8 text-slate-800">Meus Dados</h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-1">
                      <label className="text-xs font-black text-slate-400 uppercase ml-1">Nome Completo</label>
                      <input className="w-full border-2 border-slate-50 rounded-2xl p-4 outline-none focus:border-indigo-500 bg-slate-50/50" value={profile.name} onChange={(e) => setProfile({...profile, name: e.target.value})} />
                    </div>
                    <div className="space-y-1 relative">
                      <label className="text-xs font-black text-slate-400 uppercase ml-1">CPF</label>
                      <div className="relative">
                        <input type={showCpf ? "text" : "password"} className="w-full border-2 border-slate-50 rounded-2xl p-4 pr-12 outline-none bg-slate-100 text-slate-400 cursor-not-allowed" value={profile.cpf} disabled />
                        <button type="button" onClick={() => setShowCpf(!showCpf)} className="absolute right-4 top-4 text-slate-400">{showCpf ? "👁️" : "🙈"}</button>
                      </div>
                    </div>
                    <div className="space-y-1">
                      <label className="text-xs font-black text-slate-400 uppercase ml-1">Telefone</label>
                      <input className="w-full border-2 border-slate-50 rounded-2xl p-4 outline-none focus:border-indigo-500 bg-slate-50/50" value={profile.phone} onChange={(e) => setProfile({...profile, phone: e.target.value})} />
                    </div>
                    <div className="space-y-1">
                      <label className="text-xs font-black text-slate-400 uppercase ml-1">E-mail</label>
                      <input className="w-full border-2 border-slate-50 rounded-2xl p-4 outline-none focus:border-indigo-500 bg-slate-50/50" value={profile.email} onChange={(e) => setProfile({...profile, email: e.target.value})} />
                    </div>
                  </div>
                </section>

                <section className="bg-white rounded-[32px] shadow-sm border border-slate-200 p-8">
                  <h2 className="text-xl font-bold mb-8 text-slate-800">Endereço</h2>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="space-y-1">
                      <label className="text-xs font-black text-slate-400 uppercase ml-1">CEP</label>
                      <input className="w-full border-2 border-slate-50 rounded-2xl p-4 outline-none focus:border-indigo-500 bg-slate-50/50 font-bold text-indigo-600" value={profile.cep} maxLength={9} placeholder="00000-000" onChange={(e) => setProfile({...profile, cep: e.target.value})} />
                    </div>
                    <div className="md:col-span-2 space-y-1">
                      <label className="text-xs font-black text-slate-400 uppercase ml-1">Rua/Logradouro</label>
                      <input className="w-full border-2 border-slate-50 rounded-2xl p-4 outline-none focus:border-indigo-500 bg-slate-50/50" value={profile.address} onChange={(e) => setProfile({...profile, address: e.target.value})} />
                    </div>
                    <div className="space-y-1">
                      <label className="text-xs font-black text-slate-400 uppercase ml-1">Número</label>
                      <input id="address_number" className="w-full border-2 border-slate-50 rounded-2xl p-4 outline-none focus:border-indigo-500 bg-slate-50/50" value={profile.number} onChange={(e) => setProfile({...profile, number: e.target.value})} />
                    </div>
                    <div className="space-y-1">
                      <label className="text-xs font-black text-slate-400 uppercase ml-1">Complemento</label>
                      <input className="w-full border-2 border-slate-50 rounded-2xl p-4 outline-none focus:border-indigo-500 bg-slate-50/50" value={profile.complement} onChange={(e) => setProfile({...profile, complement: e.target.value})} />
                    </div>
                    <div className="space-y-1">
                      <label className="text-xs font-black text-slate-400 uppercase ml-1">Bairro</label>
                      <input className="w-full border-2 border-slate-50 rounded-2xl p-4 outline-none focus:border-indigo-500 bg-slate-50/50" value={profile.neighborhood} onChange={(e) => setProfile({...profile, neighborhood: e.target.value})} />
                    </div>
                    <div className="md:col-span-2 space-y-1">
                      <label className="text-xs font-black text-slate-400 uppercase ml-1">Cidade</label>
                      <input className="w-full border-2 border-slate-50 rounded-2xl p-4 outline-none focus:border-indigo-500 bg-slate-50/50" value={profile.city} onChange={(e) => setProfile({...profile, city: e.target.value})} />
                    </div>
                    <div className="space-y-1">
                      <label className="text-xs font-black text-slate-400 uppercase ml-1">Estado (UF)</label>
                      <input className="w-full border-2 border-slate-50 rounded-2xl p-4 outline-none focus:border-indigo-500 bg-slate-50/50" value={profile.state} onChange={(e) => setProfile({...profile, state: e.target.value})} />
                    </div>
                  </div>
                  <button onClick={saveProfile} disabled={saving} className="mt-10 w-full md:w-auto bg-indigo-600 text-white px-12 py-4 rounded-2xl font-black hover:bg-indigo-700 shadow-xl shadow-indigo-100 transition-all">
                    {saving ? "Salvando..." : "Salvar Alterações"}
                  </button>
                </section>
              </div>

              <div className="space-y-6">
                <section className="bg-white rounded-[32px] shadow-sm border border-slate-200 p-8">
                  <h2 className="text-xl font-bold mb-6 text-slate-800">Segurança</h2>
                  <div className="space-y-4">
                    <div className="relative">
                      <input type={showCurrentPass ? "text" : "password"} placeholder="Senha atual" className="w-full border-2 border-slate-50 rounded-2xl p-4 pr-12 outline-none focus:border-indigo-500 bg-slate-50/50" value={passwords.current} onChange={(e) => setPasswords({...passwords, current: e.target.value})} />
                      <button type="button" onClick={() => setShowCurrentPass(!showCurrentPass)} className="absolute right-4 top-4 text-slate-400">{showCurrentPass ? "👁️" : "🙈"}</button>
                    </div>
                    <div className="relative">
                      <input type={showNewPass ? "text" : "password"} placeholder="Nova senha" className="w-full border-2 border-slate-50 rounded-2xl p-4 pr-12 outline-none focus:border-indigo-500 bg-slate-50/50" value={passwords.new} onChange={(e) => setPasswords({...passwords, new: e.target.value})} />
                      <button type="button" onClick={() => setShowNewPass(!showNewPass)} className="absolute right-4 top-4 text-slate-400">{showNewPass ? "👁️" : "🙈"}</button>
                    </div>
                    <div className="relative">
                      <input type={showConfirmPass ? "text" : "password"} placeholder="Confirmar nova senha" className="w-full border-2 border-slate-50 rounded-2xl p-4 pr-12 outline-none focus:border-indigo-500 bg-slate-50/50" value={passwords.confirm} onChange={(e) => setPasswords({...passwords, confirm: e.target.value})} />
                      <button type="button" onClick={() => setShowConfirmPass(!showConfirmPass)} className="absolute right-4 top-4 text-slate-400">{showConfirmPass ? "👁️" : "🙈"}</button>
                    </div>
                    <button onClick={changePassword} disabled={saving} className="w-full py-4 bg-slate-800 text-white rounded-2xl font-bold hover:bg-slate-700 transition-all">Alterar Senha</button>
                  </div>
                </section>
              </div>
            </div>
          ) : (
             /* ABA DE PEDIDOS - DETALHADA */
            <div className="bg-white rounded-[32px] shadow-sm border border-slate-200 overflow-hidden animate-in fade-in duration-500">
              <table className="w-full text-left">
                <thead className="bg-slate-50/50 border-b">
                  <tr>
                    <th className="p-6 text-[10px] font-black text-slate-400 uppercase tracking-wider">Curso</th>
                    <th className="p-6 text-[10px] font-black text-slate-400 uppercase tracking-wider">Tipo</th>
                    <th className="p-6 text-[10px] font-black text-slate-400 uppercase tracking-wider">Valor</th>
                    <th className="p-6 text-[10px] font-black text-slate-400 uppercase tracking-wider">Data</th>
                    <th className="p-6 text-[10px] font-black text-slate-400 uppercase tracking-wider">Status</th>
                    <th className="p-6 text-[10px] font-black text-slate-400 uppercase tracking-wider text-right">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="p-20 text-center text-slate-400 font-medium">Nenhum pedido encontrado no seu histórico.</td>
                    </tr>
                  ) : (
                    orders.map((order) => (
                      <tr key={order.id} className="border-b last:border-0 group hover:bg-slate-50/30 transition-all">
                        <td className="p-6 font-bold text-slate-700">{order.course_title}</td>
                        
                        {/* NOVA COLUNA: TIPO DE TRANSAÇÃO */}
                        <td className="p-6">
                          <span className="flex items-center gap-2 text-xs font-bold text-slate-500">
                            {order.type === 'PIX' && <span>💠 PIX</span>}
                            {order.type === 'BOLETO' && <span>📄 Boleto</span>}
                            {order.type === 'CARD' && <span>💳 Cartão</span>}
                          </span>
                        </td>
            
                        <td className="p-6 text-slate-600 font-medium">R$ {Number(order.amount).toFixed(2)}</td>
                        <td className="p-6 text-slate-500 text-sm">{new Date(order.created_at).toLocaleDateString('pt-BR')}</td>
                        <td className="p-6">
                          <span className={`px-3 py-1 rounded-full text-[10px] font-black uppercase ${order.status === 'PAID' ? 'bg-emerald-100 text-emerald-600' : 'bg-amber-100 text-amber-600'}`}>
                            {order.status === 'PAID' ? 'Aprovado' : 'Pendente'}
                          </span>
                        </td>
                        <td className="p-6 text-right">
                          {order.type === 'BOLETO' && order.status !== 'PAID' && (
                            <button onClick={() => setSelectedBoleto(order.transaction_id)} className="bg-indigo-600 text-white px-5 py-2 rounded-xl font-bold text-xs hover:bg-indigo-700 transition-all">Ver Boleto</button>
                          )}
                          {order.status === 'PAID' && <span className="text-emerald-500 text-xs font-bold italic">Pago ✅</span>}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {selectedBoleto && (
        <div className="fixed inset-0 z-[100] bg-slate-900/90 backdrop-blur-md flex items-center justify-center p-4">
          <div className="bg-white rounded-[40px] w-full max-w-5xl h-[90vh] flex flex-col overflow-hidden shadow-2xl relative">
            <div className="p-6 border-b flex justify-between items-center bg-slate-50">
              <h2 className="text-xl font-black text-slate-800">Visualizar Boleto</h2>
              <button onClick={() => setSelectedBoleto(null)} className="w-10 h-10 rounded-full bg-slate-200 text-slate-600 font-bold hover:bg-red-500 hover:text-white transition-all">✕</button>
            </div>
            <div className="flex-1 bg-slate-800">
              <iframe src={`${selectedBoleto}#toolbar=0`} className="w-full h-full border-none" title="Boleto" />
            </div>
          </div>
        </div>
      )}
    </AppLayout>
  );
}